import { ActionContext, ActionTree } from "vuex";
import { IAuthState, ICredentials } from "@/store/modules/auth/types";
import { RootState } from "@/store/types";
import { ApiCaller } from "@/ApiCaller";

type AuthActionContext = ActionContext<IAuthState, RootState>;
type AuthActionTree = ActionTree<IAuthState, RootState>;

const api = ApiCaller.getInstance();

export const actions: AuthActionTree = {
  async login(context: AuthActionContext, payload: ICredentials): Promise<any> {
    const response = await api.post("auth/login", payload);
    await context.dispatch("doLogin", response.data.token);
  },

  async apiLogin(context: AuthActionContext, api_key: string): Promise<any> {
    const response = await api.post("auth/api-login", { api_key });
    await context.dispatch("doLogin", response.data.token);
  },

  async doLogin(context: AuthActionContext, token: string): Promise<any> {
    context.commit("setToken", token);
    await api.get("auth/sections");
    await context.dispatch("flowModule/start", {}, { root: true });
  },

  async unsetToken(context: AuthActionContext): Promise<void> {
    ApiCaller.getInstance().configureHeaders(null);
    context.commit("unsetToken");
  },

  async recoveryPassword(
    context: AuthActionContext,
    username: string
  ): Promise<any> {
    await api.post("auth/password-recovery", { username });
  },

  async permissions(context: AuthActionContext): Promise<any> {
    const { data } = await api.get("auth/permissions");
    const etl = context.rootGetters["flowModule/etl"];

    data.permissions.homeRoomOn = 1;
    context.commit("setUser", data);
    context.commit("setLogged", true);
  },

  async checkHomeRoonOn(context: AuthActionContext): Promise<void> {
    const { data } = await api.get("auth/home-room-on");

    context.commit("setHomeRoomOn", data.homeRoomOn);
  },

  async complete(context: AuthActionContext) {
    context.commit("complete");
  },
};
